export default __webpack_public_path__ + "static/media/moon.c4a18069.svg";